import {
  Component,
  OnInit,
  ViewChild,
  SimpleChanges,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { HelpdeskService } from "src/app/services/delavci/helpdesk.service";
import { LoginPartnerService } from "src/app/services/partner/login-partner/login-partner.service";

import { MatLegacyPaginator as MatPaginator } from "@angular/material/legacy-paginator";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { Task } from "src/app/models/Task";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { MainService } from "src/app/services/delavci/main.service";
import { UntypedFormControl, FormArray } from "@angular/forms";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MatDatepicker } from "@angular/material/datepicker";
import * as moment from "moment";
import * as _ from "lodash";
import { Partner } from "src/app/models/Partner";
import { User } from "src/app/models/User";

import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { Cooperations } from "src/app/models/Cooperations";
import { SelectionModel } from "@angular/cdk/collections";
import { FilterSession } from "src/app/models/FilterSession";
import { timeParser } from "src/app/utils/timeParser";
import { timer } from "rxjs";
import { DeviceDetectorService } from "ngx-device-detector";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { DialogDodajDelavcaComponent } from "../dialog-dodaj-delavca/dialog-dodaj-delavca.component";
import { HelpersService } from "src/app/services/shared/helpers.service";
import { extendMoment } from 'moment-range';
import { UrediTaskComponent } from "../uredi-task/uredi-task.component";
import { timeParserOneElement } from "src/app/utils/timeParserOneElement";
import { Workers } from "src/app/models/Workers";
import { TranslocoService } from "@ngneat/transloco";
const { range } = extendMoment(moment);
export const MY_FORMATS = {
  parse: {
    dateInput: "DD.MM.YYYY",
  },
  display: {
    dateInput: "DD.MM.YYYY",
    monthYearLabel: "DD.MM.YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "DD.MM.YYYY",
  },
};

@Component({
  selector: "app-pregled-helpdeska",
  templateUrl: "./pregled-helpdeska.component.html",
  styleUrls: ["./pregled-helpdeska.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class PregledHelpdeskaComponent implements OnInit, OnDestroy {
  public displayedColumns: string[];
  public displayedColumnsMobile: string[];
  public taskData: Array<Task> = [];
  public dataSource: any = new MatTableDataSource<Task>(this.taskData);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public dataRow: Task;
  public partnerLoggedIn = false;
  public statusChecker = [
    { color: "yellow", status: 1, selected: false },
    { color: "red", status: 29, selected: false },
    { color: "blue", status: 30, selected: false },
    { color: "green", status: 26, selected: false },
    { color: "gray", status: 361, selected: false },
    { color: "brown", status: 97, selected: false },
    { color: "darkBlue", status: 385, selected: false },
    { color: "pink", status: 411, selected: false },
    { color: "purple", status: 386, selected: false },
    { color: "black", status: 387, selected: false }
  ];
  public filterValue;
  public startDate = new Date();
  public newDataSource: any[] = [];
  public tempDataSource: any[] = [];
  public dateFrom = new UntypedFormControl(moment().subtract(30, "days"));
  public dateTo = new UntypedFormControl(moment());
  public sessionUserPartner;
  public currentUserPartner: Partner;
  public currentUserWorker: User;
  public spinner = true;
  public search;
  public dateToday = false;
  public dateTomorrow = false;
  public filterUnknown = false;
  public showUnread = false;
  public pageSize;
  public displayedColumnsCooperation: string[] = ["code", "select"];
  public selection = new SelectionModel<Cooperations>(true, []);

  public getFilterSession: FilterSession;
  public cooperationsFromAPI: Array<Cooperations>;
  public clearedCheckboxes = false;
  public selectedCooperations: Cooperations;
  public selectedWorkers: Workers;
  public cooperationsList: Array<Cooperations>;
  public workersList: Array<Workers>;
  public refreshTimerSub;
  public refreshPeriod;
  public isMobile;
  public filterToggle;
  public communicationIdChat;
  public todayOrTommorow;
  public lastInfoButton: boolean = false
  public numberOfUnreadMessages;
  constructor(
    private helpdeskService: HelpdeskService,
    private loginPartnerService: LoginPartnerService,
    private mainService: MainService,
    private router: Router,
    private _snackbar: MatSnackBar,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog,
    private helperService: HelpersService,
    private translocoService: TranslocoService
  ) {
  }
  ngOnDestroy(): void {
    if (this.refreshTimerSub) {
      this.refreshTimerSub.unsubscribe();
    }
  }

  ngOnInit() {
    
    this.helpdeskService.currentHelpdeskParameters.subscribe(data => {
      this.communicationIdChat = data.communicationIdChat;
    });
    if(localStorage.getItem('lastTaskId')){
      this.lastInfoButton = true;
    }
    else {
      this.lastInfoButton = false;
    }


    this.helpdeskService.helpdeskQuickRefresher.subscribe(value => {
      this.filter(false);
    });
    this.helpdeskService.currentHelpdeskFilterToggle.subscribe((data) => {
      this.filterToggle = data === "true";
    });
    this.isMobile = this.deviceService.isMobile();
    this.helpdeskService.currentRefreshPeriod.subscribe((refresh) => {
      this.refreshPeriod = refresh;
      if (this.refreshTimerSub) {
        this.refreshTimerSub.unsubscribe();
      }
      if (this.refreshPeriod && Number(this.refreshPeriod) > 0) {
        this.refreshTimer();
      }
    });

    this.pageSize = this.helpdeskService.currentpaginatorPageSize;
    if (!this.loginPartnerService.currentSessionValue) {
      this.sessionUserPartner = null;
    } else {
      this.sessionUserPartner = this.loginPartnerService.currentSessionValue;
    }
    if (!this.loginPartnerService.currentPartnerValue) {
      this.currentUserPartner = null;
    } else {
      this.currentUserPartner = this.loginPartnerService.currentPartnerValue;
    }
    if (!this.mainService.currentUserValue) {
      this.currentUserWorker = null;
    } else {
      this.currentUserWorker = this.mainService.currentUserValue;
    }
    if (this.loginPartnerService.currentPartnerValue) {
      this.partnerLoggedIn = true;
      this.displayedColumns = [
        "textPartner",
        "tsBooked",
        "statusNameSmall",
        "statusColor",
        "timespendMin",
        "partnerTitleSmall",
        "communicationTypeNameSmall",
        "numberOfUnreadMessages",
        "toProcessButton",
      ];
      this.displayedColumnsMobile = ["textMobile", "statusColor", "workFirstNameCurrent", "toProcessButton",];
    } else {
      this.displayedColumns = [
        "text",
        "tsBooked",
        "nextContact",
        "statusColor",
        "timespendMin",
        "partnerTitleSmall",
        "numberOfUnreadMessages",
        "workFirstNameCurrent",
        "completed",
        "toProcessButton",
        "uredi",
        "toHelpdeskTabButton",
        "addDaysButton"
      ];
      this.displayedColumnsMobile = [
        "textMobile",
        "statusColor",
        "partnerTitleSmall",
        "workFirstNameCurrent",
        "uredi",
        "toProcessButton"
      ];
    }
    //new Task mam, da je neka tabela na začetku že vidna, da ne skoči iz 0 elementov na 10
    this.dataSource = new MatTableDataSource([
      new Task(),
      new Task(),
      new Task(),
      new Task(),
      new Task(),
      new Task(),
      new Task(),
      new Task(),
    ]);
    
    this.cooperationsCall();
    this.workersCall();
    this.helpdeskService.currentFilterSession.subscribe(
      (data) => {
        
        if(data) {
          
          this.getFilterSession = data
          if (this.getFilterSession.text) {
            this.search = this.getFilterSession.text;
          }
          this.showUnread = this.getFilterSession.unread;
          this.filterUnknown = this.getFilterSession.unknown;
          this.dateToday = this.getFilterSession.today;
          this.dateTomorrow = this.getFilterSession.tomorrow;
          this.todayOrTommorow = this.getFilterSession.todayOrTomorrow;
          let statuses = [];
          if (this.getFilterSession.statuses) {
            statuses = this.getFilterSession.statuses;
            for (let item of statuses) {
              for (let i = 0; i < this.statusChecker.length; i++) {
                if (item == this.statusChecker[i].status) {
                  this.statusChecker[i].selected = true;
                }
              }
            }
          }
            
          if (this.getFilterSession.cooperations !== null) {
            this.selectedCooperations = this.getFilterSession.cooperations;
          }
          if (this.getFilterSession.workers !== null) {
            this.selectedWorkers = this.getFilterSession.workers;
          }
          if (this.getFilterSession.dateFrom) {
            this.dateFrom.setValue(
              moment(this.getFilterSession.dateFrom, "DD.MM.YYYY")
            );
          }
          if (this.getFilterSession.dateTo) {
            this.dateTo.patchValue(
              moment(this.getFilterSession.dateTo, "DD.MM.YYYY")
            );
          }
          this.filterHelpDeskCall(statuses);
        } else {
          this.serviceHelpdeskCall();
        }
        
      }
    );
    //this.paginator._intl.itemsPerPageLabel = 'Število taskov na stran';
    this.console(this.sessionUserPartner +
      this.currentUserWorker +
      this.currentUserPartner);
  }

  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  
  refreshTimer() {
    let miliseconds = Number(this.refreshPeriod) * 60000;
    this.refreshTimerSub = timer(0, miliseconds).subscribe(() => {
      this.spinner = true;
      let statuses = [];
      if (this.getFilterSession) {
        if (this.getFilterSession.statuses) {
          statuses = this.getFilterSession.statuses;
          for (let item of statuses) {
            for (let i = 0; i < this.statusChecker.length; i++) {
              if (item == this.statusChecker[i].status) {
                this.statusChecker[i].selected = true;
              }
            }
          }
        }
      }
      this.filterHelpDeskCall(statuses);
    });
  }

  console(row) {
    for (let item of this.getFilterSession.cooperations) {
      if (item == row) {
        //console.log("true");
      } else {
        // console.log("false")
      }
    }
  }

  cooperationsCall() {
    this.helpdeskService
      .getCooperationHelpdesk(this.currentUserWorker, this.currentUserPartner)
      .subscribe(
        (data) => {
          this.cooperationsList = data.data.cooperations;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  workersCall() {
    
    this.helpdeskService
      .getWorkerHelpdesk(this.currentUserWorker, this.currentUserPartner)
      .subscribe(
        (data) => {
          this.workersList = data.data.workers;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  serviceHelpdeskCall() {
    this.resetFilterSession();
    let showNextContactCurrent = this.boolToNumberOutput(this.dateToday);
    let showUnknownAnswer = this.boolToNumberOutput(this.filterUnknown);
    let showUnreadTasks = this.boolToNumberOutput(this.showUnread);

    this.helpdeskService
      .getHelpDesk(
        this.sessionUserPartner,
        this.currentUserWorker,
        this.currentUserPartner,
        0,
        0,
        0
      )
      .subscribe(
        (data) => {
          
          this.taskData = timeParser(data.data.tasks);
          
          this.dataSource = new MatTableDataSource(this.taskData);
          
         //this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.spinner = false;
          this.setDatasourceSorting();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  setDatasourceSorting() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'tsBooked':
          return (moment(item.tsBooked, 'DD.MM.YYYY hh:mm').valueOf());
        case 'nextContact':
          return (moment(item.nextContact, 'DD.MM.YYYY').valueOf());
        default: return item[property];
      }
    };
  }
  setTaskStatus(selectedStatus, dataRow: Task) {
    this.dataRow = dataRow;
    this.helpdeskService.setTaskStatus(
      this.mainService.currentUserValue, this.dataRow.text, this.dataRow.id, selectedStatus, this.dataRow.contactId, this.communicationIdChat).subscribe( data => {
        this.helpdeskService.helpdeskQuickRefresher.emit("da");
        this.spinner = true;
        let statuses = [];
        if (this.getFilterSession) {
          if (this.getFilterSession.statuses) {
            statuses = this.getFilterSession.statuses;
            for (let item of statuses) {
              for (let i = 0; i < this.statusChecker.length; i++) {
                if (item == this.statusChecker[i].status) {
                  this.statusChecker[i].selected = true;
                }
              }
            }
          }
        }
      this.filterHelpDeskCall(statuses);
      }, error => {
        console.log(error);
        this._snackbar.open(error.error.errorUser , '', {
          duration: 2000,
        });
      });
  }
  serviceOneHelpdeskRowCall(dataRow) {
    
    this.helpdeskService
      .getOneHelpdeskRow(
        this.sessionUserPartner,
        this.currentUserWorker,
        this.currentUserPartner,
        dataRow.id
      )
      .subscribe(
        (data) => {
          this.taskData = timeParser(data.data.tasks);
          this.dataSource;
          //this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.spinner = false;
          this.setDatasourceSorting();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  toSetTask() {
    this.router.navigate(["/prijavi-napako"]);
  }

  toUredi(dataRow: Task) {
    localStorage.setItem("lastTaskId", JSON.stringify(dataRow.id));
    this.helpdeskService.changeDataRow(dataRow);
    
    this.router.navigate(["/uredi-task/" + dataRow.id], { queryParams: { zavihek: 'description'} });
  }

  addDatum1(row: Task) {
    this.helpdeskService
      .setTaskDate(
        this.loginPartnerService.currentSessionValue,
        this.loginPartnerService.currentPartnerValue,
        this.mainService.currentUserValue,
        row.text,
        row.id,
        1,
        row.contactId,
        this.communicationIdChat
      )
      .subscribe(
        (data) => {
          //this.serviceHelpdeskCall();
          this.filter(false);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  addDatum2(row: Task) {
    this.helpdeskService
      .setTaskDate(
        this.loginPartnerService.currentSessionValue,
        this.loginPartnerService.currentPartnerValue,
        this.mainService.currentUserValue,
        row.text,
        row.id,
        2,
        row.contactId,
        this.communicationIdChat
      )
      .subscribe(
        (data) => {
          //this.serviceHelpdeskCall();
          this.filter(false);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  addDatum7(row: Task) {
    this.helpdeskService
      .setTaskDate(
        this.loginPartnerService.currentSessionValue,
        this.loginPartnerService.currentPartnerValue,
        this.mainService.currentUserValue,
        row.text,
        row.id,
        7,
        row.contactId,
        this.communicationIdChat
      )
      .subscribe(
        (data) => {
          //this.serviceHelpdeskCall();
          this.filter(false);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  onAmWorking(row) {
    this.helpdeskService
      .setCurrentWorker(this.mainService.currentUserValue, row.id)
      .subscribe(
        (data) => {
          //this.serviceHelpdeskCall();
          this.filter(false);
        },
        (error) => {
          console.log(error);
          this._snackbar.open(
            "S to vrstico, že morda nekdo upravlja. Osvežite stran in poskusite znova.",
            "",
            {
              duration: 2000,
            }
          );
        }
      );
    this.serviceOneHelpdeskRowCall(row);
  }

  onStopWorking(row) {
    this.helpdeskService
      .deleteCurrentWorker(this.mainService.currentUserValue, row.id)
      .subscribe(
        (data) => {
          //this.serviceHelpdeskCall();
          this.filter(false);
        },
        (error) => {
          console.log(error);
          this._snackbar.open(
            "S to vrstico, že morda nekdo upravlja. Osvežite stran in poskusite znova.",
            "",
            {
              duration: 2000,
            }
          );
        }
      );
  }

  /* koda za filter statusa*/
  filterStatusChecker(color: string) {
    for (let item of this.statusChecker) {
      if (item.color === color) {
        if (item.selected) {
          item.selected = false;
        } else {
          item.selected = true;
        }
      }
    }
  }

  //Vsi statusi so false oz. disabled.
  statusDisableAll() {
    for (let item of this.statusChecker) {
      item.selected = false;
    }
  }

  filter(toggle) {
    //Se zgodi, če je klicano direktno iz gumba filtriraj! To bo zaprlo filter.
    if(toggle){
      this.filterToggle = !this.filterToggle;
      this.helpdeskService.changeHelpdeskFilterToggle(
        this.filterToggle.toString()
      );
    }
    //allFalse je checker za status. Če je true, uporabnik ni klikno nobenega statusa za filtriranje.
    this.saveFilterToSession();
    let allFalse = true;
    this.newDataSource = [];
    this.tempDataSource = [];
    let statuses = [];

    for (let item of this.statusChecker) {
      if (item.selected) {
        this.newDataSource = [];
        allFalse = false;
        statuses.push(item.status);
      }
    }

    //če noben status ni obkljukan
    if (allFalse) {
      //če je search vnos (text) določen

      this.filterHelpDeskCall(statuses);
    } else {
      this.filterHelpDeskCall(statuses);
      statuses = [];
    }
  }

  change(dateEvent) {
    this.dateFrom = dateEvent;
  }

  //To se uporabi takrat, ko WS hoče 0 in 1 in ne false in true.
  boolToNumberOutput(inputBool) {
    if (inputBool) {
      return 1;
    } else {
      return 0;
    }
  }

  //FILTRIRA, ČE JE NASTAVLJEN IN STATUS FILTER IN DATE FILTER IN SEARCH (lahko je search tudi null no)
  filterHelpDeskCall(statuses) {
    this.spinner = true;
    let showNextContactCurrent;
    let showNextContactTomorrow;
    if(this.todayOrTommorow) {
      if(this.todayOrTommorow === 'tomorrow') {
        showNextContactTomorrow = 1;
      }
      if(this.todayOrTommorow === 'today') {
        showNextContactCurrent = 1;
      }
    }

    let showUnknownAnswer = this.boolToNumberOutput(this.filterUnknown);

    let showUnreadTasks = this.boolToNumberOutput(this.showUnread);


    this.helpdeskService
      .getHelpDeskByFilterAll(
        this.sessionUserPartner,
        this.currentUserWorker,
        this.currentUserPartner,
        statuses,
        moment(this.dateFrom.value).format("DD.MM.YYYY"),
        moment(this.dateTo.value).format("DD.MM.YYYY"),
        this.search,
        showNextContactCurrent,
        showNextContactTomorrow,
        showUnknownAnswer,
        this.selectedCooperations,
        this.selectedWorkers,
        showUnreadTasks
      )
      .subscribe(
        (data) => {
          let filteredTasks = timeParser(data.data.tasks);
          this.dataSource = new MatTableDataSource(filteredTasks);
          if(this.partnerLoggedIn)
            this.helperService.checkIfMessageExists(this.dataSource);
          
          //this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.filter = this.filterValue;
          this.spinner = false;
          this.setDatasourceSorting();
        },
        (error) => {
          console.log(error);
        }
      );
      console.log("cooperation" + this.selectedCooperations);
  }

  returnLastInfo(){
    if(localStorage.getItem('lastTaskId') !== undefined && localStorage.getItem('lastTaskId') !== null){
      let lastTaskId = JSON.parse(localStorage.getItem('lastTaskId'));
      this.router.navigate(["/uredi-task/" + lastTaskId], { queryParams: { zavihek: 'description'} });
    }
  }

  filterOnlyDate() {
    let tempDateDataSource;
    this.helpdeskService
      .getHelpDeskByFilterDate(
        this.sessionUserPartner,
        this.currentUserWorker,
        this.currentUserPartner,
        moment(this.dateFrom.value).format("DD.MM.YYYY"),
        moment(this.dateTo.value).format("DD.MM.YYYY"),
        this.search
      )
      .subscribe(
        (data) => {
          tempDateDataSource = timeParser(data.data.tasks);
          this.dataSource = new MatTableDataSource(tempDateDataSource);
          //this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.setDatasourceSorting();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  onDateTodayChange() {
    if (this.dateToday) {
      this.dateToday = false;
    } else {
      this.dateToday = true;
    }
  }

  onDateTomorrowChange() {
    if (this.dateTomorrow) {
      this.dateTomorrow = false;
    } else {
      this.dateTomorrow = true;
    }
  }

  onFilterUnknownChange() {
    if (this.filterUnknown) {
      this.filterUnknown = false;
    } else {
      this.filterUnknown = true;
    }
  }

  onFilterUnreadChange() {
    if (this.showUnread) {
      this.showUnread = false;
    } else {
      this.showUnread = true;
    }
  }

  onPageSizeOptions(event) {
    this.helpdeskService.changePaginatorPageSize(event.pageSize);
  }
  resetFilterSession() {

    let sessionFilter: FilterSession = {
      text: "",
      dateFrom: moment().subtract(30, "days").format("DD.MM.YYYY"),
      dateTo: moment().format("DD.MM.YYYY"),
      today: false,
      tomorrow: false,
      todayOrTomorrow: null,
      unknown: false,
      unread: false,
      statuses: [],
      cooperations: [],
      workers: [],
    };
    this.dateFrom = new UntypedFormControl(moment().subtract(30, "days"));
    this.dateTo = new UntypedFormControl(moment());
    this.dateToday = false;
    this.dateTomorrow = false;
    this.filterUnknown = false;
    this.showUnread = false;
    this.selectedCooperations = null;
    this.selectedWorkers = null;
    this.statusDisableAll();
    this.search = null;
    this.helpdeskService.changeFilterSession(sessionFilter);

  }
  saveFilterToSession() {
    let statuses = [];
    for (let item of this.statusChecker) {
      if (item.selected) {
        statuses.push(item.status);
      }
    }

    let sessionFilter: FilterSession = {
      text: this.search,
      dateFrom: moment(this.dateFrom.value).format("DD.MM.YYYY"),
      dateTo: moment(this.dateTo.value).format("DD.MM.YYYY"),
      today: this.dateToday,
      tomorrow: this.dateTomorrow,
      todayOrTomorrow: this.todayOrTommorow,
      unknown: this.filterUnknown,
      unread: this.showUnread,
      statuses: statuses,
      cooperations: this.selectedCooperations,
      workers: this.selectedWorkers,
    };

    this.helpdeskService.changeFilterSession(sessionFilter);

    /* saving page refresh period to localStorage */
    this.helpdeskService.changeRefreshPeriod(this.refreshPeriod);
  }

  changePartnerForTab(element) {
    localStorage.setItem("tabContactId", element.contactId);
    if (this.isMobile) {
      this.router.navigate(["/helpdesk-tab"]);
    }
  }

  hammerSwipe() {
    if (this.isMobile) {
      this.router.navigate(["/helpdesk-tab"]);
    }
  }

  toHelpdeskTab(row: Task) {
    localStorage.setItem('tabContactId', row.contactId.toString());
    this.router.navigate(["/helpdesk-tab"]);
  }

  openDialog(row: Task) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
        taskId: row.id,
        taskText: row.text
    };

    const dialogRef = this.dialog.open(DialogDodajDelavcaComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if(data) {
        this.filter(false);
      }
    });
}
  statusTooltip(colorId) {
    return this.helperService.statusTooltip(colorId);
  }

  countAllDataRows() {
    return this.dataSource.data.length;
  }

}
